<template>
<div>
    <div class="post-editor">
        <RenameUploadModal ref="renameModal" @confirm="renameConfirmed"></RenameUploadModal>
        <SelectFileModal ref="genericFileModal" @selected="selected" title="Attach File" />
        <editor-menu-bubble v-show="editor.isActive.uploadfile()" :editor="editor" :keep-in-bounds="keepInBounds" v-slot="{ commands, isActive, menu }">
            <div class="editor__bubble-menu" :style="`top: ${CalculateTopBasic()}px;`" :class="{ 'is-active': isActive.uploadfile() }">

                <button @click="renameUploadClick('renameModal')" tabindex="-1">
                    <i class="icon icon-square-edit"></i>
                </button>
                <button tabindex="-1" @click="deleteSelected">
                    <i class="icon icon-bin"></i>
                </button>

            </div>
        </editor-menu-bubble>
        <editor-content ref="editorContent" class="editor__content" :editor="editor"></editor-content>
    </div>
</div>
</template>

<script>
import {
    Selection,
    NodeSelection
} from "prosemirror-state";
import SelectFileModal from "@/../submodules/vue-base/tiptap/modals/SelectFileModal";
import RenameUploadModal from "@/../submodules/vue-base/tiptap/modals/RenameUploadModal";

import {
    Editor,
    EditorContent,
    EditorMenuBubble,
} from 'tiptap';
import {
    Placeholder,
} from 'tiptap-extensions';
import UploadFile from '@/../submodules/vue-base/tiptap/nodes/UploadFile';
import {
    v4 as uuidv4
} from 'uuid';

import GeneralHelpers from "@/../submodules/vue-base/tiptap/common/GeneralHelpers";
import PositionHelpers from "@/../submodules/vue-base/tiptap/common/PositionHelpers";
import AttachmentHelpers from "@/../submodules/vue-base/tiptap/common/AttachmentHelpers";


export default {
    components: {
        EditorContent,
        SelectFileModal,
        EditorMenuBubble,
        RenameUploadModal
    },

	mixins: [
        GeneralHelpers,
        PositionHelpers,
        AttachmentHelpers,
    ],

    data() {
        return {
            ready: false,
            haveFloating: false,
            showFloating: false,
            showPlus: true,
            keepInBounds: true,
            objectUrls: [],
            editor: new Editor({
                autoFocus: false,
                extensions: [
                    new UploadFile(),
                    new Placeholder({
                        showOnlyCurrent: false,
                        emptyNodeText: node => {
                            return "Message"
                        },
                    }),

                ],

            }),
            json: {},
            html: '',
        }
    },
    mounted() {
        this.html = this.editor.getHTML();

    },
    methods: {
        clear() {
            this.editor.clearContent()
        },

        openGenericModal() {
            this.$refs.genericFileModal.open();
        },

        cleanup() {

            for (var i = 0; i < this.objectUrls.length; i++) {
                URL.revokeObjectURL(this.objectUrls[i]);
            }

        },


    },
}
</script>
